export default __webpack_public_path__ + "static/media/txt.702a94ff.svg";